import ThreeDSMethodsRadioGroup from './ThreeDSMethodsRadioGroup';

export default ThreeDSMethodsRadioGroup;